@if (loading) {
  <app-loader />
}

@if (!loading) {
  <div class="md-content rd-3">
    <i class="material-icons md-close" (click)="close()">close</i>
    <!-- Block imported from Google Calendar: read-only -->
    @if (isGoogleImport) {
      <div class="md-header text-center">
        <h3>{{ 'SHARED.createHolidayModal.googleTitle' | translate }}</h3>
        <p>{{ store?.name }}</p>
      </div>
      <div class="md-body">
        @if (event.reason) {
          <p class="tw:mb-2 tw:text-base tw:font-semibold">{{ event.reason }}</p>
        }
        <p class="tw:mb-1">{{ googleStart | date: 'short' }} &ndash; {{ googleEnd | date: 'short' }}</p>
        @if (event.provider?.name) {
          <p class="tw:mb-1">{{ event.provider.name }}</p>
        }
        @if (event.googleEventUrl) {
          <a
            [href]="event.googleEventUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="tw:mb-3 tw:inline-flex tw:items-center tw:gap-1 tw:text-sm"
            >
            <i class="material-icons tw:!text-base">open_in_new</i>
            {{ 'SHARED.createHolidayModal.openInGoogle' | translate }}
          </a>
        }
        <app-alert
          [msg]="(event.googleImportBroken ? 'SHARED.createHolidayModal.googleBroken' : 'SHARED.createHolidayModal.googleReadOnly') | translate"
          [type]="event.googleImportBroken ? 'warning' : 'info'"
          >
          @if (canReconnectGoogle) {
            <button type="button" class="tw:border-0 tw:bg-transparent tw:p-0 tw:font-bold tw:underline" (click)="goToAccount()">
              {{ 'SHARED.createHolidayModal.googleReconnectCta' | translate }}
            </button>
          }
        </app-alert>
      </div>
    }
    @if (form && !isGoogleImport) {
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="md-header text-center">
          @if (!event) {
            <h3>{{ 'SHARED.createHolidayModal.title' | translate }}</h3>
          }
          @if (event) {
            <h3>{{ 'GENERAL.edit' | translate }}</h3>
          }
          <!-- <h3 *ngIf="!event" class="sm-title">{{form.get('dateInitDay').value | dateFix | date:'longDate'}}</h3> -->
          <p>{{ store?.name }}</p>
        </div>
        <div class="md-body">
          <div class="row">
            <div class="col-6">
              <label>{{ 'SHARED.createHolidayModal.startDateLabel' | translate }}</label>
              <!-- desktop -->
              <input
                class="form-control no-mobile"
                readonly="true"
                bsDatepicker
                formControlName="dateInitDay"
                [bsConfig]="bsConfig"
                />
              <!-- mobile -->
              <input
                class="form-control just-mobile"
                [value]="form.get('dateInitDay').value | date: 'dd/MM/yyyy'"
                (click)="dateInitDayPickerMobile = true"
                />
              @if (dateInitDayPickerMobile) {
                <app-mobile-date-picker title="{{ 'SHARED.createHolidayModal.startDateLabel' | translate }}"
                  [bsConfig]="bsConfig"
                  [bsValue]="form.get('dateInitDay').value"
                  (bsValueChange)="form.patchValue({ dateInitDay: $event })"
                  (modalDismiss)="dateInitDayPickerMobile = false"
                   />
              }
            </div>
            <div class="col-6 pl-0">
              <div class="nomb form-row">
                <div class="col">
                  <app-dropdown-input label="{{ 'SHARED.createBookingModal.hours' | translate }}"
                    formControlName="dateInitTimeHour"
                    [options]="availableHours"
                    [submitAttempted]="submitAttempted"
                    placeholder="{{ 'SHARED.createBookingModal.hour' | translate }}"
                    invalidMsg="{{ 'SHARED.createBookingModal.hourInvalid' | translate }}"
                   />
                </div>
                <div class="col">
                  <app-dropdown-input label="{{ 'SHARED.createBookingModal.minutes' | translate }}"
                    formControlName="dateInitTimeMinutes"
                    [options]="availableMinutes"
                    [submitAttempted]="submitAttempted"
                    placeholder="{{ 'SHARED.createBookingModal.minutes' | translate }}"
                    invalidMsg="{{ 'SHARED.createBookingModal.hourInvalid' | translate }}"
                   />
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-6">
              <label>{{ 'SHARED.createHolidayModal.endDateLabel' | translate }}</label>
              <!-- desktop -->
              <input
                class="form-control no-mobile"
                readonly="true"
                bsDatepicker
                formControlName="dateEndDay"
                [bsConfig]="bsConfig"
                />
              <!-- mobile -->
              <input
                class="form-control just-mobile"
                [value]="form.get('dateEndDay').value | date: 'dd/MM/yyyy'"
                (click)="dateEndDayPickerMobile = true"
                />
              @if (dateEndDayPickerMobile) {
                <app-mobile-date-picker title="{{ 'SHARED.createHolidayModal.endDateLabel' | translate }}"
                  [bsConfig]="bsConfig"
                  [bsValue]="form.get('dateEndDay').value"
                  (bsValueChange)="form.patchValue({ dateEndDay: $event })"
                  (modalDismiss)="dateEndDayPickerMobile = false"
                   />
              }
            </div>
            <div class="col-6 pl-0">
              <div class="nomb form-row">
                <div class="col">
                  <app-dropdown-input label="{{ 'SHARED.createBookingModal.hours' | translate }}"
                    formControlName="dateEndTimeHour"
                    [options]="availableHours"
                    [submitAttempted]="submitAttempted"
                    placeholder="{{ 'SHARED.createBookingModal.hour' | translate }}"
                    invalidMsg="{{ 'SHARED.createBookingModal.hourInvalid' | translate }}"
                   />
                </div>
                <div class="col">
                  <app-dropdown-input label="{{ 'SHARED.createBookingModal.minutes' | translate }}"
                    formControlName="dateEndTimeMinutes"
                    [options]="availableMinutes"
                    [submitAttempted]="submitAttempted"
                    placeholder="{{ 'SHARED.createBookingModal.minutes' | translate }}"
                    invalidMsg="{{ 'SHARED.createBookingModal.hourInvalid' | translate }}"
                   />
                </div>
              </div>
            </div>
          </div>
          @if (form.errors?.invalidEndDate) {
            <app-alert [msg]="'SHARED.createHolidayModal.invalidEndDate' | translate" type="warning" />
          }
          <app-dropdown-input label="{{ 'SHARED.createHolidayModal.providerLabel' | translate }}"
            inputClasses="mt-2"
            formControlName="provider"
            [options]="providers"
            optionProperty="name"
            [submitAttempted]="submitAttempted"
            placeholder="{{ 'SHARED.createHolidayModal.providerPlaceholder' | translate }}"
            invalidMsg="{{ 'SHARED.createHolidayModal.providerInvalid' | translate }}"
           />
          <app-text-input label="{{ 'SHARED.createHolidayModal.reasonLabel' | translate }}"
            [hasMarginB]="false"
            formControlName="reason"
            [submitAttempted]="submitAttempted"
            placeholder="{{ 'SHARED.createHolidayModal.reasonPlaceholder' | translate }}"
            invalidMsg="{{ 'SHARED.createHolidayModal.reasonMaxLength' | translate }}"
            inputType="text"
           />
          @if (!event) {
            <div class="custom-control custom-checkbox mt-3">
              <input
                formControlName="recurrentCheck"
                type="checkbox"
                [checked]="false"
                (change)="toggleRecurrent($event)"
                class="custom-control-input"
                id="recurrentCheck"
                />
              <label class="custom-control-label" for="recurrentCheck">
                {{ 'SHARED.createHolidayModal.recurrentEvent' | translate }}
              </label>
            </div>
          }
          @if (!event && isRecurrent) {
            <div class="row mt-3">
              <div class="col-6">
                <app-dropdown-input label="{{ 'SHARED.createHolidayModal.repeatLabel' | translate }}"
                  inputClasses=""
                  formControlName="recurrent"
                  [options]="recurrentOptions"
                  optionProperty="name"
                  [submitAttempted]="submitAttempted"
                 />
              </div>
              <div class="col-6">
                <div class="nomb">
                  @if (isRecurrent) {
                    <label>{{ 'SHARED.createHolidayModal.until' | translate }}</label>
                  }
                  <!-- desktop -->
                  @if (isRecurrent) {
                    <input
                      class="form-control no-mobile"
                      formControlName="recurrentUntil"
                      [ngClass]="{ 'is-invalid': submitAttempted && form.get('recurrentUntil').invalid }"
                      bsDatepicker
                      placement="top"
                      [minDate]="minDate"
                      [bsConfig]="bsConfig"
                      />
                  }
                  <!-- mobile -->
                  @if (isRecurrent) {
                    <input
                      class="form-control just-mobile"
                      readonly="true"
                      [value]="form.get('recurrentUntil').value | date: 'dd/MM/yyyy'"
                      (click)="recurrentUntilPickerMobile = true"
                      [ngClass]="{ 'is-invalid': submitAttempted && form.get('recurrentUntil').invalid }"
                      />
                  }
                  @if (recurrentUntilPickerMobile) {
                    <app-mobile-date-picker title="{{ 'SHARED.createBookingModal.until' | translate }}"
                      [bsConfig]="bsConfig"
                      [minDate]="minDate"
                      [bsValue]="form.get('recurrentUntil').value"
                      (bsValueChange)="form.patchValue({ recurrentUntil: $event })"
                      (modalDismiss)="recurrentUntilPickerMobile = false"
                       />
                  }
                </div>
              </div>
            </div>
          }
        </div>
        <app-alert [msg]="errorMsg" type="danger" />
        <div class="md-actions px-4">
          <div class="row">
            <div class="col">
              @if (canDeleteEvent()) {
                <button type="button" class="btn btn-md btn-secondary float-left" (click)="deleteHoliday()">
                  {{ 'SHARED.createHolidayModal.ctaDelete' | translate }}
                </button>
              }
              @if (canCreateEvent()) {
                <app-submit-btn [loading]="saving"
                  [hasError]="errorMsg"
                  [btnCopy]="event ? ('SHARED.createHolidayModal.ctaSave' | translate) : ('SHARED.createHolidayModal.ctaBlock' | translate)"
                 />
              }
            </div>
          </div>
        </div>
      </form>
    }
  </div>
}